import type { FindValueObjectMap } from "./dynamicVariables.d";

const numberFormatRegex = /\B(?=(\d{3})+(?!\d))/g;

export const formatValue = (value: number | string, separator = "") =>
  String(value).replace(numberFormatRegex, separator);

export const findValue = (objectMap: FindValueObjectMap, key: string) => {
  const objectKeys = Object.keys(objectMap);
  const objectKey = objectKeys.find((item) => item.split(",").find((item) => item === key)) || "fallback";

  return objectMap[objectKey];
};
